import { render, staticRenderFns } from "./AlertRelatedUsers.vue?vue&type=template&id=78202b9d&scoped=true&"
import script from "./AlertRelatedUsers.vue?vue&type=script&lang=js&"
export * from "./AlertRelatedUsers.vue?vue&type=script&lang=js&"
import style0 from "./AlertRelatedUsers.vue?vue&type=style&index=0&id=78202b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78202b9d",
  null
  
)

export default component.exports